import unique from 'array-unique';
import { countryAliases, iso3166CountryMap } from '../config/countries';
export default class CountryUtil {
    static mapCountriesForSuggestionField(searchTerm) {
        return this.findSuggestedCountries(searchTerm).map((country) => ({ label: country.name, url: '' }));
    }
    static findSuggestedCountries(searchTerm) {
        const foundCountries = this.getCountriesContainingSearchTerm(searchTerm);
        const aliasCountries = this.findByAlias(searchTerm);
        return unique(foundCountries.concat(aliasCountries).sort((country1, country2) => country1.name.localeCompare(country2.name)));
    }
    static findByAlias(searchTerm) {
        return countryAliases.filter((country) => this.countryMatchesSearchTerm(country, searchTerm)).map((alias) => this.getByCountryCode(alias.code));
    }
    static getByCountryCode(code) {
        if (!code) {
            return { code: 'OTHER', name: 'Muu' };
        }
        return code === 'OTHER' ? { code, name: 'Muu' } : iso3166CountryMap.find((country) => country.code === code);
    }
    static getSelectedCountry(searchTerm) {
        const countries = this.findSuggestedCountries(searchTerm);
        return countries.length === 1 ? countries[0] : null;
    }
    static countryMatchesSearchTerm(country, searchTerm) {
        const name = country.name.toLowerCase();
        const nameFragments = name.replace('-', ' ').split(' ');
        const nameFragmentsMatchTerm = () => nameFragments.some((nameFragment) => this.startsWith(nameFragment, searchTerm));
        return this.startsWith(name, searchTerm) || nameFragmentsMatchTerm();
    }
    static getCountriesContainingSearchTerm(searchTerm) {
        return iso3166CountryMap.filter((country) => this.countryMatchesSearchTerm(country, searchTerm));
    }
    static startsWith(name, searchTerm) {
        return name.startsWith(searchTerm.trim().toLowerCase());
    }
    static isEstonia(code) {
        return code === 'EE';
    }
}
